/* eslint-disable @scandipwa/scandipwa-guidelines/only-render-in-component */

import { FIREBASE_EDPOINT, PAGE_LOGGED_ERROR } from 'Route/SomethingWentWrong/SomethingWentWrong.config';
import {
    App as SourceApp
} from 'SourceComponent/App/App.component';
/** @namespace Bodypwa/Component/App/Component */
export class AppComponent extends SourceApp {
    __construct(props) {
        super.__construct(props);
        this.configureAppBasedOnEnvironment();
        this.configureApp();
        if (process.env.NODE_ENV === 'production') {
            this.logError();
        }
    }

    logError() {
        const data = window.localStorage?.getItem(PAGE_LOGGED_ERROR);
        if (data) {
            window.localStorage.removeItem(PAGE_LOGGED_ERROR);
            fetch(FIREBASE_EDPOINT, {
                method: 'POST',
                body: data,
                headers: {
                    'Content-Type': 'application/json'
                }
            })
                .then(
                    /** @namespace Bodypwa/Component/App/Component/AppComponent/logError/then/catch/then/then/fetch/then */
                    (response) => response.json()
                )
                .then(
                    /** @namespace Bodypwa/Component/App/Component/AppComponent/logError/then/catch/then/then */
                    (data) => {
                        console.log('Success:', data);
                    }
                )
                .catch(
                    /** @namespace Bodypwa/Component/App/Component/AppComponent/logError/then/catch */
                    (error) => {
                        console.error('Error:', error);
                    }
                );
        }
    }

    // eslint-disable-next-line @scandipwa/scandipwa-guidelines/only-render-in-component
    componentDidCatch(err, info) {
        this.setState({
            hasError: true,
            errorDetails: { err, info }
        });
    }
}

export default AppComponent;
